import { getAPI , putAPI } from "../../api/apis"
import { REACT_APP_CANDIDATE } from "../../utils/common"


export async function submitProfilePicture(body: any) {
    const Details = putAPI(REACT_APP_CANDIDATE + '/candidates', body)
    return Details
}

export async function getBasicProfileValues(id: any) {
    const Details = getAPI(REACT_APP_CANDIDATE + `/candidates/${id}`)
    return Details
}